import { render, staticRenderFns } from "./AssessmentScoreOnLine.vue?vue&type=template&id=f95ccd88&scoped=true"
import script from "./AssessmentScoreOnLine.vue?vue&type=script&lang=js"
export * from "./AssessmentScoreOnLine.vue?vue&type=script&lang=js"
import style0 from "./AssessmentScoreOnLine.vue?vue&type=style&index=0&id=f95ccd88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95ccd88",
  null
  
)

export default component.exports